export const EXTERNAL_SALES_BASE_PATH = '/external-sales';
